import React from 'react';
import classNames from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import styles from 'assets/jss/material-dashboard-pro-react/components/cardFooterStyle.js';

// @ts-ignore
const useStyles = makeStyles(styles);

interface ICardFooterProps {
	className: string;
	plain?: boolean;
	profile?: boolean;
	pricing?: boolean;
	testimonial?: boolean;
	stats?: boolean;
	chart?: boolean;
	product?: boolean;
	children: string | React.ReactElement;
}

function CardFooter({
	className,
	children,
	plain,
	profile,
	pricing,
	testimonial,
	stats,
	chart,
	product,
	...rest
}: ICardFooterProps) {
	const classes = useStyles();
	const cardFooterClasses = classNames({
		[classes.cardFooter]: true,
		[classes.cardFooterPlain]: plain,
		[classes.cardFooterProfile]: profile || testimonial,
		[classes.cardFooterPricing]: pricing,
		[classes.cardFooterTestimonial]: testimonial,
		[classes.cardFooterStats]: stats,
		[classes.cardFooterChart]: chart || product,
		[className]: className !== undefined,
	});
	return (
		<div className={cardFooterClasses} {...rest}>
			{children}
		</div>
	);
}

export default CardFooter;
